import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import Link from 'components/Link';
import UserAvatar from 'components/UserAvatar';

import { AvatarShape } from 'entities';
import { getUserProfile } from 'selectors';
import './style.scss';

class UserSettingsAvatarHeader extends Component {

  render() {
    return (
      <div className="UserSettingsAvatarHeader">
        <div className="avatar">
          <UserAvatar size="large" letter={this.props.userName[0]} imageUrl={this.props.avatar.url} />
        </div>
        {process.env.FEATURES.avatars === true &&
          <Link to="/settings/avatar">{__('members.settings.avatarLink')}</Link>
        }
      </div>
    );
  }
}

UserSettingsAvatarHeader.propTypes = {
  avatar: AvatarShape,
  userName: PropTypes.string
};

const mapStateToProps = state => getUserProfile(state);
const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSettingsAvatarHeader);




/** WEBPACK FOOTER **
 ** ./src/members/Main/UserSettings/UserSettingsAvatarHeader/index.js
 **/